(() => {
  const root = document.getElementById('naf-reviews-root');
  const body = document.getElementById('naf-reviews-body');
  if (!root || !body || !root.dataset.productHandle) return;

  const handle = root.dataset.productHandle;
  const apiBase = root.dataset.apiBase;
  const LIMIT = 10;
  let offset = 0;

  function el(tag, cls, text) {
    const node = document.createElement(tag);
    if (cls) node.className = cls;
    if (text !== undefined) node.textContent = text;
    return node;
  }

  // Stars: filled for the rating, hollow for the rest (never innerHTML user text).
  function stars(rating, max) {
    const wrap = el('span', 'naf-reviews__stars');
    for (let i = 1; i <= (max || 5); i++) {
      const s = el('span', i <= rating ? 'full' : 'empty');
      s.textContent = i <= rating ? '★' : '☆';
      wrap.appendChild(s);
    }
    return wrap;
  }

  function fmtDate(iso) {
    const d = new Date(iso);
    if (isNaN(d.getTime())) return '';
    return d.toLocaleDateString(undefined, { year: 'numeric', month: 'long', day: 'numeric' });
  }

  // ---- Summary + list shell + form (static shell, user content added via DOM) ----
  const summary = el('div', 'naf-reviews__summary');
  const avg = el('span', 'naf-reviews__avg', '');
  const summaryStars = el('span', 'naf-reviews__stars');
  const count = el('span', 'naf-reviews__count', '');
  summary.append(avg, summaryStars, count);

  const list = el('div', 'naf-reviews__list');

  const loadMore = el('button', 'naf-reviews__loadmore button', 'Load more');
  loadMore.type = 'button';
  loadMore.hidden = true;
  loadMore.addEventListener('click', () => load(false));

  // ---- Form ----
  const form = el('form', 'naf-reviews__form');
  form.innerHTML = `
    <h3>Write a review</h3>
    <div class="naf-reviews__grid">
      <div class="naf-reviews__field">
        <label for="naf-rv-name">Your name</label>
        <input type="text" id="naf-rv-name" name="name" maxlength="100" required>
      </div>
      <div class="naf-reviews__field">
        <label for="naf-rv-email">Email</label>
        <input type="email" id="naf-rv-email" name="email" maxlength="200" required>
      </div>
      <div class="naf-reviews__field">
        <label for="naf-rv-order">Order number (optional — verifies your purchase)</label>
        <input type="text" id="naf-rv-order" name="order_ref" maxlength="50" placeholder="e.g. #1234">
      </div>
      <div class="naf-reviews__field naf-reviews__rating">
        <span>Rating</span>
        <div>
          <label><input type="radio" name="rating" value="5" checked> 5</label>
          <label><input type="radio" name="rating" value="4"> 4</label>
          <label><input type="radio" name="rating" value="3"> 3</label>
          <label><input type="radio" name="rating" value="2"> 2</label>
          <label><input type="radio" name="rating" value="1"> 1</label>
        </div>
      </div>
      <div class="naf-reviews__field naf-reviews__field--full">
        <label for="naf-rv-title">Title (optional)</label>
        <input type="text" id="naf-rv-title" name="title" maxlength="200">
      </div>
      <div class="naf-reviews__field naf-reviews__field--full">
        <label for="naf-rv-body">Your review</label>
        <textarea id="naf-rv-body" name="body" maxlength="3000" required></textarea>
      </div>
      <div class="naf-reviews__hp" aria-hidden="true">
        <label for="naf-rv-website">Leave this field empty</label>
        <input type="text" id="naf-rv-website" name="website" tabindex="-1" autocomplete="off">
      </div>
    </div>
    <button type="submit" class="naf-reviews__submit button">Submit review</button>
    <p class="naf-reviews__status" hidden></p>
  `;

  const status = form.querySelector('.naf-reviews__status');

  form.addEventListener('submit', async (e) => {
    e.preventDefault();
    status.hidden = true;
    const rating = form.querySelector('input[name="rating"]:checked');
    const payload = {
      name: form.querySelector('#naf-rv-name').value.trim(),
      email: form.querySelector('#naf-rv-email').value.trim(),
      order_ref: form.querySelector('#naf-rv-order').value.trim(),
      rating: parseInt(rating ? rating.value : '5', 10),
      title: form.querySelector('#naf-rv-title').value.trim(),
      body: form.querySelector('#naf-rv-body').value.trim(),
      website: form.querySelector('#naf-rv-website').value,
    };
    try {
      const resp = await fetch(`${apiBase}/products/${encodeURIComponent(handle)}/reviews`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
        cache: 'no-store',
      });
      if (!resp.ok) throw new Error(`request failed (${resp.status})`);
      status.className = 'naf-reviews__status success';
      status.textContent = 'Thank you! Your review has been submitted and will appear once approved.';
      status.hidden = false;
      form.reset();
    } catch (err) {
      status.className = 'naf-reviews__status error';
      status.textContent = 'Something went wrong submitting your review. Please try again.';
      status.hidden = false;
    }
  });

  function renderSummary() {
    return fetch(`${apiBase}/products/${encodeURIComponent(handle)}/reviews?limit=${LIMIT}&offset=0`, { cache: 'no-store' })
      .then((resp) => {
        if (!resp.ok) throw new Error(`request failed (${resp.status})`);
        return resp.json();
      })
      .then((data) => {
        const agg = data.aggregate || { avg: 0, count: 0 };
        avg.textContent = agg.count > 0 ? agg.avg.toFixed(1) : '';
        summaryStars.replaceChildren();
        summaryStars.appendChild(stars(Math.round(agg.avg), 5));
        count.textContent = agg.count > 0
          ? `${agg.count} review${agg.count === 1 ? '' : 's'}`
          : 'No reviews yet';
        summary.hidden = false;
      });
  }

  function reviewCard(r) {
    const card = el('article', 'naf-reviews__card');

    const head = el('div', 'naf-reviews__card-head');
    const nameWrap = el('div');
    const name = el('h4', 'naf-reviews__name', r.reviewer_name);
    nameWrap.appendChild(name);
    if (r.verified) nameWrap.appendChild(el('span', 'naf-reviews__verified', '✓ Verified buyer'));
    head.appendChild(nameWrap);
    head.appendChild(el('span', 'naf-reviews__date', fmtDate(r.created_at)));
    card.appendChild(head);

    card.appendChild(stars(r.rating, 5));
    if (r.title) card.appendChild(el('p', 'naf-reviews__title', r.title));
    card.appendChild(el('p', 'naf-reviews__body', r.body));

    if (r.admin_response) {
      const resp = el('div', 'naf-reviews__response');
      resp.appendChild(el('strong', '', 'Response from Not a Feesh'));
      resp.appendChild(el('span', '', r.admin_response));
      card.appendChild(resp);
    }
    return card;
  }

  function load(reset) {
    if (reset) offset = 0;
    const url = `${apiBase}/products/${encodeURIComponent(handle)}/reviews?limit=${LIMIT}&offset=${offset}`;
    return fetch(url, { cache: 'no-store' })
      .then((resp) => {
        if (!resp.ok) throw new Error(`request failed (${resp.status})`);
        return resp.json();
      })
      .then((data) => {
        if (reset) {
          list.replaceChildren();
          if ((data.aggregate || {}).count === 0) {
            list.appendChild(el('p', 'naf-reviews__muted', 'No reviews yet — be the first to share your experience.'));
          }
        }
        (data.reviews || []).forEach((r) => list.appendChild(reviewCard(r)));
        offset += (data.reviews || []).length;
        loadMore.hidden = offset >= (data.aggregate || {}).count;
      })
      .catch(() => {
        if (reset) {
          list.replaceChildren();
          list.appendChild(el('p', 'naf-reviews__muted', 'Reviews are temporarily unavailable. Please check back later.'));
        }
      });
  }

  body.replaceChildren(summary, list, loadMore, form);
  renderSummary().then(() => load(true));
})();
